export default __webpack_public_path__ + "static/media/customer.92e4a2e9.svg";